import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function usePreventBFCache (){
    const { isAuthenticated } = useAuth0();
    const navigate = useNavigate();

    

    useEffect(() => {
        function handlePageShow (event){
            event.preventDefault();
            if( event.persisted ){
                navigate("/");
            }
        }
        
        window.addEventListener('pageshow', handlePageShow);

        return ()=> {
            window.removeEventListener('pageshow', handlePageShow);
        }
    }, [isAuthenticated, navigate]);
}

export default usePreventBFCache;